import React, { memo, useCallback } from "react";
import styles from "./BetNumber.module.css";
import CloseIcon from "./CloseIcon";
import SelectedIcon from "./SelectedIcon";

const BetNumber: React.FC<{
  number: string;
  type?:
    | "default"
    | "selected"
    | "solid"
    | "user"
    | "user-win"
    | "win"
    | "diamond";
  size?: "default" | "small" | "xs" | "xxs";
  isDiamond?: boolean;
  onClick: (number: string) => void;
}> = ({
  number,
  type = "default",
  size = "default",
  isDiamond = false,
  onClick,
}) => {
  const handleClick = useCallback(() => {
    onClick(number);
  }, [onClick, number]);

  return (
    <>
      <div style={{ position: "relative" }} onClick={handleClick}>
        <div
          className={`${styles.button} ${styles[`size-${size}`]} ${
            isDiamond ? styles.diamond : styles[type]
          } `}
        >
          {number}
        </div>
        {type === "selected" && (
          <CloseIcon size={size === "xxs" ? "xs" : size} />
        )}
        {type === "user-win" && (
          <SelectedIcon size={size === "xxs" ? "xs" : size} />
        )}
      </div>
    </>
  );
};

// Memoize to prevent unnecessary re-renders
export default memo(BetNumber);
